module.exports = __webpack_public_path__ + "static/img/home_img_2.ed3a128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img_2.png
// module id = o6yW
// module chunks = 0